var map = {
	"./cloudy-day-3.svg": "64be",
	"./cloudy-night-3.svg": "73cd",
	"./cloudy.svg": "f623",
	"./day.svg": "bdb7",
	"./night.svg": "4ed4",
	"./rainy-2.svg": "12ac",
	"./rainy-5.svg": "5c36",
	"./snowy-5.svg": "618d",
	"./thunder.svg": "04cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";